import {
  ColumnLayout,
  Container,
  Header,
  SpaceBetween,
} from '@cloudscape-design/components';
import PLCCheckboxEditor from 'features/plc/components/PLCCheckboxEditor';
import PLCNumberEditor from 'features/plc/components/PLCNumberEditor';
import {
  getFieldLimits,
  getTestStandModeConfig,
  SETUP_TYPE,
  SUB_MODE,
  TS_PATHS,
} from 'features/plc/contracts/testStand.schema';
import { usePLCValue } from 'features/plc/providers/PLCProvider';
import PropTypes from 'prop-types';
import React from 'react';

import { useTestStand } from '../../providers/TestStandProvider';
import ChannelMetadataFields from './ChannelFields';

function ChannelPLCFields({
  paths,
  setupType = SETUP_TYPE.CONTINUOUS_FLOW,
  subMode = SUB_MODE.DISPLACEMENT,
}) {
  const { fields } = getTestStandModeConfig(setupType, subMode);
  const columnsNum = setupType === SETUP_TYPE.DISCRETE_FLOW ? 3 : 2;

  return (
    <ColumnLayout columns={columnsNum}>
      {fields.map(([label, key]) => {
        const field = {
          label,
          path: paths.cmd.params[key],
          ...getFieldLimits(key),
        };

        return field.path.type === 'BOOL' ? (
          <PLCCheckboxEditor key={key} field={field} />
        ) : (
          <PLCNumberEditor key={key} field={field} />
        );
      })}
    </ColumnLayout>
  );
}
ChannelPLCFields.propTypes = {
  paths: PropTypes.shape({
    cmd: PropTypes.shape({
      params: PropTypes.objectOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
      })).isRequired,
    }).isRequired,
  }).isRequired,
  setupType: PropTypes.number,
  subMode: PropTypes.number,
};

function ChannelSection({
  title,
  metadata,
  onMetadataChange,
  paths,
  setupType = SETUP_TYPE.CONTINUOUS_FLOW,
  subMode = SUB_MODE.DISPLACEMENT,
}) {
  return (
    <Container header={<Header variant="h3">{title}</Header>}>
      <SpaceBetween size="m">
        <ChannelPLCFields paths={paths} setupType={setupType} subMode={subMode} />
        <ChannelMetadataFields params={metadata} onChange={onMetadataChange} />
      </SpaceBetween>
    </Container>
  );
}
ChannelSection.propTypes = {
  title: PropTypes.string.isRequired,
  metadata: PropTypes.shape({
    info: PropTypes.string.isRequired,
  }).isRequired,
  onMetadataChange: PropTypes.func.isRequired,
  paths: PropTypes.shape({}).isRequired,
  setupType: PropTypes.number,
  subMode: PropTypes.number,
};

export default function ParameterForm() {
  const {
    state,
    setLipidMetadata,
    setAqueousMetadata,
  } = useTestStand();
  const setupType = usePLCValue(TS_PATHS.run.setupType) || 1;
  const subMode = usePLCValue(TS_PATHS.run.subMode) || 1;

  return (
    <Container header={<Header variant="h2">Parameters</Header>}>
      <SpaceBetween size="m">
        <ChannelSection
          title="Lipid channel"
          metadata={state.channelMetadata.lipid}
          onMetadataChange={setLipidMetadata}
          paths={TS_PATHS.lipid}
          setupType={setupType}
          subMode={subMode}
        />
        <ChannelSection
          title="Aqueous channel"
          metadata={state.channelMetadata.aqueous}
          onMetadataChange={setAqueousMetadata}
          paths={TS_PATHS.aqueous}
          setupType={setupType}
          subMode={subMode}
        />
      </SpaceBetween>
    </Container>
  );
}
